import { v4 as uuid } from "uuid";
import { message, } from "../message";
export const command = ({ messageId, occurredOn, name, aggregateId = uuid(), }) => ({
    aggregateId,
    ...message({ messageId, occurredOn, name }),
});
